import { MetaInfo } from "@/components/meta-info"
import { SettingsHeader } from "../settings-header"
import { AiDraftsSection } from "./ai-drafts-section"

export function AiDraftsPage() {
	return (
		<>
			<MetaInfo title="AI Drafts Settings" />

			<SettingsHeader
				title="AI Drafts"
				subtitle="Populate the composer with a draft reply in the background."
			/>

			<AiDraftsSection />
		</>
	)
}
